import { Site } from "../../../typings";
import { sitesPipelineStore } from "../store";
import { useSnapshot } from "valtio";

export const useSiteBySiteId = (siteId: string) => {
  const { siteBySiteId } = useSnapshot(sitesPipelineStore);

  return (siteBySiteId[siteId] as Site) ?? null;
};
